class SlideBuilder {
	constructor(slideData, position = null) {
		this.slideData = slideData;
		this.position = position;
		this.slide = this.createSlide();
		this.tagSlide();
	}

	createSlide() {
		// Network slide is not generated from the template
		if (this.slideData.id === 'network') {
			const heroSlider = document.querySelector('.hero-slider').__slider;
			if (heroSlider && heroSlider.networkSlide) {
				const networkSlide = heroSlider.networkSlide.cloneNode(true);
				return networkSlide;
			}
		}

		const template = this.getTemplateFromCache();
		const slide = template.cloneNode(true).querySelector('.slide');

		this.updateSlideContent(slide);
		return slide;
	}

	getTemplateFromCache() {
		if (!SlideBuilder.templateCache) {
			const template = document.getElementById('slide-template');
			SlideBuilder.templateCache = template.content.cloneNode(true);
		}
		return SlideBuilder.templateCache.cloneNode(true);
	}

	updateSlideContent(slide) {
		slide.href = this.slideData.link;

		const updates = {
			'[data-slot="title"]': { textContent: this.slideData.title },
			'[data-slot="description"]': {
				innerHTML: this.slideData.description,
				shouldRemove: !this.slideData.description
			},
			video: {
				src: this.slideData.video,
				shouldRemove: !this.slideData.video,
				poster: this.slideData.image
			},
			'[data-slot="poster"]': {
				src: this.slideData.image,
				srcset: `${this.slideData.image_2x} 2x`,
				alt: this.slideData.title,
				shouldRemove: this.slideData.video
			}
		};

		Object.entries(updates).forEach(([selector, update]) => {
			const element = slide.querySelector(selector);
			if (!element) return;

			if (update.shouldRemove) {
				element.remove();
				return;
			}

			Object.entries(update).forEach(([prop, value]) => {
				if (value !== null && value !== undefined) {
					element[prop] = value;
				}
			});
		});

		if (this.slideData.config.vertical_in_horizontal) {
			this.buildVerticalInHorizontal(slide);
		}

		this.updateMetadata(slide);
		slide.querySelector('video')?.load();
	}

	updateMetadata(slide) {
		if (!this.slideData.metadata.is_new) {
			slide.querySelector('[data-template="new"]')?.remove();
		}

		const episodeEl = slide.querySelector('[data-template="episode-id"]');
		if (this.slideData.objects.episode_id) {
			episodeEl.querySelector('span').textContent = this.slideData.objects.episode_id;
		} else {
			episodeEl?.remove();
		}

		const qualityEl = slide.querySelector('[data-template="quality"]');
		if (this.slideData.objects.video_quality) {
			qualityEl.querySelector('span').textContent = this.slideData.objects.video_quality;
			qualityEl.setAttribute('data-quality', this.slideData.objects.video_quality);
		} else {
			qualityEl?.remove();
		}
	}

	tagSlide(position = this.position) {
		if (position === 'prev') {
			this.slide.dataset.sliderItem = '-1';
		} else if (position === 'next') {
			this.slide.dataset.sliderItem = '1';
		} else if (position === 'active') {
			this.slide.dataset.sliderItem = 0;
		}
	}

	buildVerticalInHorizontal(slide) {
		const mediaContainer = slide.querySelector('.slide__media');
		if (!mediaContainer) return;

		mediaContainer.classList.add('slide__media--vertical-in-horizontal');

		const leftContainer = document.createElement('div');
		leftContainer.className = 'column slide__media--vertical-in-horizontal__left';

		const leftImage = document.createElement('img');
		leftImage.className = 'prbn__media';
		leftImage.src = this.slideData.config.vertical_in_horizontal_media.image_1;
		leftImage.srcset = this.slideData.config.vertical_in_horizontal_media.image_1_2x;

		leftContainer.appendChild(leftImage);

		const rightContainer = document.createElement('div');
		rightContainer.className = 'column slide__media--vertical-in-horizontal__right';

		const rightImage = document.createElement('img');
		rightImage.className = 'prbn__media';
		rightImage.src = this.slideData.config.vertical_in_horizontal_media.image_2;
		rightImage.srcset = this.slideData.config.vertical_in_horizontal_media.image_2_2x;

		rightContainer.appendChild(rightImage);

		const mainColumn = mediaContainer.querySelector('.column');
		mediaContainer.insertBefore(leftContainer, mainColumn);
		mediaContainer.appendChild(rightContainer);
	}
}

function tagSlideElement(slideElement, position) {
	if (position === 'prev') {
		slideElement.dataset.sliderItem = '-1';
	} else if (position === 'next') {
		slideElement.dataset.sliderItem = '1';
	} else if (position === 'active') {
		slideElement.dataset.sliderItem = 0;
	}
}

class HeroSlider {
	constructor(slides) {
		this.slides = slides;
		this.currentSlide = 0;
		this.slider = document.querySelector('.hero-slider');
		this.slidesContainer = this.slider.querySelector('.hero-slider__slides');
		this.bulletsContainer = null;
		this.bullets = null;

		this.prevSlide = this.slides[this.getPrevIndex()];
		this.activeSlide = this.slides[this.currentSlide];
		this.nextSlide = this.slides[this.getNextIndex()];

		this.activeVideo = null;
		this.isAnimating = false;
		this.prevBulletWindowStart = 0;
		this.isMuted = true;
		this.loopButton = null;
		this.loopButtonListeners = {
			mouseenter: null,
			mouseleave: null
		};

		this.is_network = this.slides[0].id === 'network';
		this.networkSlide = null;
		this.is_vertical = this.slider.classList.contains('hero-slider--vertical');

		this.slider.__slider = this;

		this.TOTAL_SLIDES = this.slides.length;
		this.VISIBLE_BULLETS = 5;
		this.LEFT_MORE_INDEX = 1;
		this.RIGHT_MORE_INDEX = 7;
		this.FIRST_VISIBLE_INDEX = 2;
		this.LAST_VISIBLE_INDEX = 6;

		this.slideTimeout = null;

		this.init();
	}

	init() {
		this.slider.classList.add('hero-slider--initialized');

		if (this.is_network) {
			this.networkSlide = this.slider.querySelector('.slide[data-slider-item="0"]').cloneNode(true);
		}

		if (this.TOTAL_SLIDES > 1) {
			this.initSlides();
			this.initAutoplay();
			this.initTouchEvents();
			//this.updateDebugger();
			this.initLoopButton();
		} else {
			// For single slide, just set up the active slide element
			this.activeVideo = this.slider.querySelector('.slide[data-slider-item="0"] video');
			if (this.activeVideo) {
				this.activeVideo.loop = true;
			}
		}

		this.initControls();
	}

	/*updateDebugger() {
		this.debugger = this.slider.querySelector('.hero-slider__debugger');
		this.debugger.querySelector('#prev-slide-value').textContent = this.prevSlide.id;
		this.debugger.querySelector('#current-slide-value').textContent = this.activeSlide.id;
		this.debugger.querySelector('#next-slide-value').textContent = this.nextSlide.id;
	}*/

	getPrevIndex() {
		return (this.currentSlide - 1 + this.TOTAL_SLIDES) % this.TOTAL_SLIDES;
	}
	getNextIndex() {
		return (this.currentSlide + 1) % this.TOTAL_SLIDES;
	}

	initSlides() {
		this.activeSlideEl = this.slider.querySelector('.slide[data-slider-item="0"]');
		this.prevSlideEl = this.renderSlide(this.slides[this.getPrevIndex()], 'prev');
		this.nextSlideEl = this.renderSlide(this.slides[this.getNextIndex()], 'next');
	}

	renderSlide(slideData, position) {
		const slideEl = new SlideBuilder(slideData, position).slide;

		const video = slideEl.querySelector('video');
		if (video) {
			video.muted = this.isMuted;
		}

		if (position === 'prev') {
			this.slidesContainer.prepend(slideEl);
			this.prevSlide = slideData;
		} else if (position === 'next') {
			this.slidesContainer.appendChild(slideEl);
			this.nextSlide = slideData;
		}

		return slideEl;
	}

	updateSlider(direction = 1) {
		if (this.isAnimating) return;
		this.isAnimating = true;

		if (this.slideTimeout) {
			clearTimeout(this.slideTimeout);
			this.slideTimeout = null;
		}

		this.currentSlide = (this.currentSlide + direction + this.TOTAL_SLIDES) % this.TOTAL_SLIDES;

		setTimeout(() => {
			this.updateBullets(direction);
		}, 100);

		this.applyTransitionClasses(direction);
		this.videoToStop = this.activeSlideEl.querySelector('video');

		this.updateSlideStructure(direction);
		this.handleVideoTransition();

		setTimeout(() => {
			this.updateSlidePositions(direction);
			this.cleanupTransition();
			this.videoToStop?.pause();
			this.isAnimating = false;
		}, 750);
	}

	updateSliderFromTouch(direction = 1) {
		if (this.isAnimating) return;
		this.isAnimating = true;

		this.currentSlide = (this.currentSlide + direction + this.TOTAL_SLIDES) % this.TOTAL_SLIDES;

		this.updateBullets(direction);

		this.videoToStop = this.activeSlideEl.querySelector('video');

		this.updateSlideStructure(direction);
		this.handleVideoTransition();
		this.updateSlidePositions(direction);

		this.videoToStop?.pause();
		this.isAnimating = false;
	}

	applyTransitionClasses(direction) {
		const transitions = {
			forward: {
				active: 'transition-out-left',
				next: 'transition-in-right'
			},
			backward: {
				active: 'transition-out-right',
				prev: 'transition-in-left'
			}
		};

		const currentTransitions = direction === 1 ? transitions.forward : transitions.backward;
		this.activeSlideEl.classList.add(currentTransitions.active);

		if (direction === 1) {
			this.nextSlideEl.classList.add(currentTransitions.next);
		} else {
			this.prevSlideEl.classList.add(currentTransitions.prev);
		}
	}

	updateSlideStructure(direction) {
		if (direction === 1) {
			this.prevSlideEl.remove();
		} else {
			this.nextSlideEl.remove();
		}

		if (direction === 1) {
			this.updateForwardSlides();
		} else {
			this.updateBackwardSlides();
		}

		this.initLoopButton();
	}

	updateForwardSlides() {
		this.prevSlideEl = this.activeSlideEl;
		this.activeSlideEl = this.nextSlideEl;

		this.prevSlide = this.activeSlide;
		this.activeSlide = this.nextSlide;

		this.nextSlideEl = this.renderSlide(this.slides[this.getNextIndex()], 'next');
	}

	updateBackwardSlides() {
		this.nextSlideEl = this.activeSlideEl;
		this.activeSlideEl = this.prevSlideEl;

		this.nextSlide = this.activeSlide;
		this.activeSlide = this.prevSlide;

		this.prevSlideEl = this.renderSlide(this.slides[this.getPrevIndex()], 'prev');
	}

	handleVideoTransition() {
		/*
		if (this.videoToStop) {
			this.videoToStop.pause();
			this.videoToStop.currentTime = 0;
		}*/

		this.activeVideo = this.activeSlideEl.querySelector('video');
		if (this.activeVideo) {
			this.setupNewVideo();
		} else {
			this.attachSlideTimeout();
		}
	}

	setupNewVideo() {
		this.activeVideo.currentTime = 0;
		this.activeVideo.muted = this.isMuted;
		this.activeVideo.play().catch(error => {
			console.warn('Video autoplay failed:', error);
			this.attachSlideTimeout();
		});

		this.attachVideoEndListener(this.activeVideo);
		this.updatePlayPauseButton();
	}

	updatePlayPauseButton() {
		if (this.activeVideo && this.playPauseButton) {
			if (this.activeVideo.paused) {
				this.playPauseButton.innerHTML = `
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
						<path d="M0 18.18V1.7886C0 1.00649 0.857423 0.527104 1.52371 0.936704L14.6369 8.99807C15.2664 9.3851 15.2732 10.2978 14.6494 10.6941L1.5362 19.0241C0.870444 19.4471 0 18.9688 0 18.18Z" fill="white"/>
					</svg>
				`;
			} else {
				this.playPauseButton.innerHTML = `
					<svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18" fill="none">
						<path d="M0 1C0 0.447716 0.447715 0 1 0H3C3.55228 0 4 0.447715 4 1V17C4 17.5523 3.55228 18 3 18H1C0.447715 18 0 17.5523 0 17V1Z" fill="white"/>
						<path d="M8 1C8 0.447716 8.44772 0 9 0H11C11.5523 0 12 0.447715 12 1V17C12 17.5523 11.5523 18 11 18H9C8.44772 18 8 17.5523 8 17V1Z" fill="white"/>
					</svg>
				`;
			}
		}
	}

	updateSlidePositions(direction) {
		tagSlideElement(this.prevSlideEl, 'prev');
		tagSlideElement(this.activeSlideEl, 'active');
		tagSlideElement(this.nextSlideEl, 'next');

		//this.updateDebugger();
	}

	cleanupTransition() {
		const transitionClasses = [
			'transition-in-left',
			'transition-in-right',
			'transition-out-left',
			'transition-out-right'
		];

		this.slider.querySelectorAll('.slide').forEach(slide => {
			slide.classList.remove(...transitionClasses);
		});
	}

	updateBullets(direction = 0) {
		if (!this.bulletsContainer) {
			this.bulletsContainer = this.slider.querySelector('.hero-slider__bullets');
			this.bullets = this.bulletsContainer.querySelectorAll('.hero-slider__bullet');
		}

		const { start, end } = this.getBulletWindow();

		if (this.shouldAddRightBullet(direction, start, end)) {
			this.addBulletToRight();
		} else if (this.shouldAddLeftBullet(direction, start, end)) {
			this.addBulletToLeft();
		}

		this.updateBulletClasses(start, end);
	}

	shouldAddRightBullet(direction, start, end) {
		return (
			direction === 1 && (end < this.TOTAL_SLIDES - 1 || this.currentSlide < this.TOTAL_SLIDES - 2) && start > 0
		);
	}

	shouldAddLeftBullet(direction, start, end) {
		return direction === -1 && (start > 0 || this.currentSlide > 1) && end < this.TOTAL_SLIDES - 1;
	}

	addBulletToRight() {
		const newBullet = document.createElement('div');
		newBullet.className = 'hero-slider__bullet';
		this.bulletsContainer.appendChild(newBullet);
		this.bulletsContainer.removeChild(this.bulletsContainer.firstChild);
		this.bullets = this.bulletsContainer.querySelectorAll('.hero-slider__bullet');
	}

	addBulletToLeft() {
		const newBullet = document.createElement('div');
		newBullet.className = 'hero-slider__bullet';
		this.bulletsContainer.insertBefore(newBullet, this.bulletsContainer.firstChild);
		this.bulletsContainer.removeChild(this.bulletsContainer.lastChild);
		this.bullets = this.bulletsContainer.querySelectorAll('.hero-slider__bullet');
	}

	updateBulletClasses(start, end) {
		for (let i = 0; i < 9; i++) {
			const bullet = this.bullets[i];
			this.resetBulletClasses(bullet);

			if (this.isHiddenBullet(i)) {
				bullet.classList.add('hero-slider__bullet--hidden');
			} else if (this.isLeftMoreBullet(i, start)) {
				bullet.classList.add('hero-slider__bullet--more');
				bullet.onclick = () => this.goToSlide(start);
			} else if (this.isRightMoreBullet(i, end)) {
				bullet.classList.add('hero-slider__bullet--more');
				bullet.onclick = () => this.goToSlide(end);
			} else {
				this.updateVisibleBullet(bullet, i, start);
			}
		}
	}

	resetBulletClasses(bullet) {
		bullet.classList.remove(
			'hero-slider__bullet--hidden',
			'hero-slider__bullet--more',
			'hero-slider__bullet--active'
		);
	}

	isHiddenBullet(index) {
		return index === 0 || index === 8;
	}

	isLeftMoreBullet(index, start) {
		return index === this.LEFT_MORE_INDEX && start > 0;
	}

	isRightMoreBullet(index, end) {
		return index === this.RIGHT_MORE_INDEX && end < this.TOTAL_SLIDES - 1;
	}

	updateVisibleBullet(bullet, index, start) {
		const visibleIndex = index - this.FIRST_VISIBLE_INDEX;
		const slideIndex = start + visibleIndex;

		if (slideIndex < 0 || slideIndex >= this.TOTAL_SLIDES) {
			bullet.classList.add('hero-slider__bullet--hidden');
		} else {
			if (slideIndex === this.currentSlide) {
				bullet.classList.add('hero-slider__bullet--active');
			}
			bullet.onclick = () => this.goToSlide(slideIndex);
		}
	}

	renderBullets() {
		const bulletsContainer = document.createElement('div');
		bulletsContainer.className = 'hero-slider__bullets row row--center p-lr--250 m-lr-a';

		for (let i = 0; i < 9; i++) {
			const bullet = document.createElement('div');
			bullet.className = 'hero-slider__bullet';
			bulletsContainer.appendChild(bullet);
		}

		return bulletsContainer;
	}

	getBulletWindow() {
		let start = 0;
		let end = 0;

		if (this.TOTAL_SLIDES <= this.VISIBLE_BULLETS) {
			start = 0;
			end = this.TOTAL_SLIDES - 1;
		} else if (this.currentSlide <= 2) {
			start = 0;
			end = this.VISIBLE_BULLETS - 1;
		} else if (this.currentSlide >= this.TOTAL_SLIDES - 3) {
			start = this.TOTAL_SLIDES - this.VISIBLE_BULLETS;
			end = this.TOTAL_SLIDES - 1;
		} else {
			start = this.currentSlide - 2;
			end = this.currentSlide + 2;
		}

		return { start, end };
	}

	initControls() {
		const controls = document.createElement('div');
		controls.className = 'hero-slider__controls tablet-up';

		const videoControls = document.createElement('div');
		videoControls.className = 'hero-slider__controls__block';

		const playPauseButton = document.createElement('button');
		playPauseButton.className = 'hero-slider__button hero-slider__button--play-pause';
		playPauseButton.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" width="12" height="18" viewBox="0 0 12 18" fill="none">
				<path d="M0 1C0 0.447716 0.447715 0 1 0H3C3.55228 0 4 0.447715 4 1V17C4 17.5523 3.55228 18 3 18H1C0.447715 18 0 17.5523 0 17V1Z" fill="white"/>
				<path d="M8 1C8 0.447716 8.44772 0 9 0H11C11.5523 0 12 0.447715 12 1V17C12 17.5523 11.5523 18 11 18H9C8.44772 18 8 17.5523 8 17V1Z" fill="white"/>
			</svg>
		`;
		playPauseButton.addEventListener('click', () => this.togglePlayPause());

		/*
		const muteButton = document.createElement('button');
		muteButton.className = 'hero-slider__button hero-slider__button--mute';
		muteButton.innerHTML = `
			<svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99929 1.48906C9.99929 0.198169 9.91144 0.0736278 9.75645 0.0197533C9.68225 -0.000979396 9.60431 -0.00545895 9.52815 0.00663304C9.45199 0.018725 9.37947 0.0470917 9.31576 0.0897198L5.06107 3.5181H0.397114C0.300617 3.50954 0.204598 3.53885 0.130141 3.59959C0.055685 3.66033 0.00887838 3.74753 0 3.84204V10.1747C0.00905558 10.2691 0.055938 10.3562 0.130374 10.4168C0.204811 10.4773 0.30073 10.5066 0.397114 10.498H5.06178L9.31648 13.9103C9.38019 13.9529 9.4527 13.9813 9.52886 13.9934C9.60502 14.0055 9.68297 14.001 9.75716 13.9802C9.82474 13.9607 9.88444 13.921 9.92795 13.8667C9.97147 13.8125 9.99665 13.7462 10 13.6773L9.99929 1.48906Z" fill="#0D0D0D"/>
				<path d="M15.9827 2C18.6724 4.76142 18.6724 9.23858 15.9827 12M13 3.875C14.6811 5.60089 14.6811 8.39911 13 10.125" stroke="#0D0D0D" stroke-width="1.5" stroke-linecap="round"/>
			</svg>
		`;
		muteButton.addEventListener('click', () => this.toggleMute());
		*/

		videoControls.appendChild(playPauseButton);
		//videoControls.appendChild(muteButton);

		controls.appendChild(videoControls);

		if (this.TOTAL_SLIDES > 1) {
			const navControls = document.createElement('div');
			navControls.className = 'hero-slider__controls__block';

			const prevButton = document.createElement('button');
			prevButton.className = 'hero-slider__button hero-slider__button--prev scale';
			prevButton.innerHTML = `
				<svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" fill="none" viewBox="0 0 13 24">
					<path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m11.5 22-10-10 10-10"/>
				</svg>
			`;
			prevButton.addEventListener('click', () => this.updateSlider(-1));

			const nextButton = document.createElement('button');
			nextButton.className = 'hero-slider__button hero-slider__button--next scale';
			nextButton.innerHTML = `            
				<svg xmlns="http://www.w3.org/2000/svg" width="13" height="24" fill="none" viewBox="0 0 13 24">
					<path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="m1.5 2 10 10-10 10"/>
				</svg>            
			`;
			nextButton.addEventListener('click', () => this.updateSlider(1));

			navControls.appendChild(prevButton);
			navControls.appendChild(nextButton);
			controls.appendChild(navControls);

			const bullets = this.renderBullets();
			this.slider.appendChild(bullets);

			this.bulletsContainer = bullets;
			this.bullets = bullets.querySelectorAll('.hero-slider__bullet');
			this.updateBulletClasses(0, 5);
		}

		this.slider.appendChild(controls);

		this.playPauseButton = playPauseButton;
		// this.muteButton = muteButton;
	}

	togglePlayPause() {
		if (this.activeVideo) {
			if (this.activeVideo.paused) {
				this.activeVideo.play();
			} else {
				this.activeVideo.pause();
			}
			this.updatePlayPauseButton();
		}
	}

	/*
	toggleMute() {
		this.isMuted = !this.isMuted;

		// Update the mute button icon
		this.muteButton.innerHTML = this.isMuted
			? `
			<svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99929 1.48906C9.99929 0.198169 9.91144 0.0736278 9.75645 0.0197533C9.68225 -0.000979396 9.60431 -0.00545895 9.52815 0.00663304C9.45199 0.018725 9.37947 0.0470917 9.31576 0.0897198L5.06107 3.5181H0.397114C0.300617 3.50954 0.204598 3.53885 0.130141 3.59959C0.055685 3.66033 0.00887838 3.74753 0 3.84204V10.1747C0.00905558 10.2691 0.055938 10.3562 0.130374 10.4168C0.204811 10.4773 0.30073 10.5066 0.397114 10.498H5.06178L9.31648 13.9103C9.38019 13.9529 9.4527 13.9813 9.52886 13.9934C9.60502 14.0055 9.68297 14.001 9.75716 13.9802C9.82474 13.9607 9.88444 13.921 9.92795 13.8667C9.97147 13.8125 9.99665 13.7462 10 13.6773L9.99929 1.48906Z" fill="#0D0D0D"/>
				<path d="M15.9827 2C18.6724 4.76142 18.6724 9.23858 15.9827 12M13 3.875C14.6811 5.60089 14.6811 8.39911 13 10.125" stroke="#0D0D0D" stroke-width="1.5" stroke-linecap="round"/>
			</svg>
		`
			: `
			<svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M9.99929 1.48906C9.99929 0.198169 9.91144 0.0736278 9.75645 0.0197533C9.68225 -0.000979396 9.60431 -0.00545895 9.52815 0.00663304C9.45199 0.018725 9.37947 0.0470917 9.31576 0.0897198L5.06107 3.5181H0.397114C0.300617 3.50954 0.204598 3.53885 0.130141 3.59959C0.055685 3.66033 0.00887838 3.74753 0 3.84204V10.1747C0.00905558 10.2691 0.055938 10.3562 0.130374 10.4168C0.204811 10.4773 0.30073 10.5066 0.397114 10.498H5.06178L9.31648 13.9103C9.38019 13.9529 9.4527 13.9813 9.52886 13.9934C9.60502 14.0055 9.68297 14.001 9.75716 13.9802C9.82474 13.9607 9.88444 13.921 9.92795 13.8667C9.97147 13.8125 9.99665 13.7462 10 13.6773L9.99929 1.48906Z" fill="#0D0D0D"/>
				<path d="M13 4.5L18 9.5M18 4.5L13 9.5" stroke="#0D0D0D" stroke-width="1.5" stroke-linecap="round"/>
			</svg>			
		`;

		// Apply mute state to current video if it exists
		if (this.activeVideo) {
			this.activeVideo.muted = this.isMuted;
		}
	}
	*/

	initAutoplay() {
		this.activeVideo = this.activeSlideEl.querySelector('video');
		if (this.activeVideo) {
			this.attachVideoEndListener(this.activeVideo);
		} else {
			this.attachSlideTimeout();
		}
	}

	initTouchEvents() {
		let touchStartX = 0;
		let touchStartY = 0;
		let touchTimer = null;
		let isDragging = false;
		let isHorizontalSwipe = null;
		let animationFrame = null;
		let isTouchTransitioning = false;

		const TOUCH_HOLD_DURATION = 500;
		const MIN_SWIPE_DISTANCE = 30;
		const SWIPE_THRESHOLD = 0.25;
		const RESISTANCE_FACTOR = 0.6;
		const EASING = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';

		let viewportWidth = window.innerWidth;
		let maxTranslate = viewportWidth * SWIPE_THRESHOLD;

		const updateViewportCache = () => {
			viewportWidth = window.innerWidth;
			maxTranslate = viewportWidth * SWIPE_THRESHOLD;
		};

		const requestAnimFrame = callback => {
			if (animationFrame) {
				cancelAnimationFrame(animationFrame);
			}
			animationFrame = requestAnimationFrame(callback);
		};

		const applyStylesToSlides = styleUpdates => {
			const slides = [this.prevSlideEl, this.activeSlideEl, this.nextSlideEl];
			slides.forEach((slide, index) => {
				if (slide && styleUpdates[index]) {
					Object.assign(slide.style, styleUpdates[index]);
				}
			});
		};

		const applyTouchTransforms = deltaX => {
			let normalizedDelta = deltaX;

			if (Math.abs(normalizedDelta) > maxTranslate) {
				const excess = Math.abs(normalizedDelta) - maxTranslate;
				const resistedExcess = excess * RESISTANCE_FACTOR;
				normalizedDelta =
					normalizedDelta > 0 ? maxTranslate + resistedExcess : -(maxTranslate + resistedExcess);
			}

			const deltaPercent = (normalizedDelta / viewportWidth) * 100;
			const transforms = [
				{ transform: `translate3d(${-100 + deltaPercent}%, 0, 0)` },
				{ transform: `translate3d(${deltaPercent}%, 0, 0)` },
				{ transform: `translate3d(${100 + deltaPercent}%, 0, 0)` }
			];

			applyStylesToSlides(transforms);
		};

		const resetSlideTransforms = () => {
			const resetStyles = [
				{
					transform: '',
					transition: '',
					transitionProperty: '',
					transitionDuration: '',
					transitionTimingFunction: ''
				},
				{
					transform: '',
					transition: '',
					transitionProperty: '',
					transitionDuration: '',
					transitionTimingFunction: ''
				},
				{
					transform: '',
					transition: '',
					transitionProperty: '',
					transitionDuration: '',
					transitionTimingFunction: ''
				}
			];
			applyStylesToSlides(resetStyles);
		};

		const setSlideTransitions = duration => {
			const transitionStyles = [
				{
					transitionProperty: 'transform',
					transitionDuration: `${duration}ms`,
					transitionTimingFunction: EASING,
					transition: `transform ${duration}ms ${EASING}`
				},
				{
					transitionProperty: 'transform',
					transitionDuration: `${duration}ms`,
					transitionTimingFunction: EASING,
					transition: `transform ${duration}ms ${EASING}`
				},
				{
					transitionProperty: 'transform',
					transitionDuration: `${duration}ms`,
					transitionTimingFunction: EASING,
					transition: `transform ${duration}ms ${EASING}`
				}
			];
			applyStylesToSlides(transitionStyles);
		};

		const animateSlidesToPosition = (duration = 100) => {
			setSlideTransitions(duration);

			requestAnimationFrame(() => {
				const originalPositions = [
					{ transform: 'translate3d(-100%, 0, 0)' },
					{ transform: 'translate3d(0%, 0, 0)' },
					{ transform: 'translate3d(100%, 0, 0)' }
				];
				applyStylesToSlides(originalPositions);

				setTimeout(() => {
					resetSlideTransforms();
				}, duration + 10);
			});
		};

		const cleanup = () => {
			if (animationFrame) {
				cancelAnimationFrame(animationFrame);
				animationFrame = null;
			}
			if (touchTimer) {
				clearTimeout(touchTimer);
				touchTimer = null;
			}
		};

		const resetState = () => {
			isDragging = false;
			isHorizontalSwipe = null;
		};

		this.slider.addEventListener(
			'touchstart',
			e => {
				if (this.isAnimating || isTouchTransitioning) {
					e.preventDefault();
					return;
				}

				touchStartX = e.changedTouches[0].clientX;
				touchStartY = e.changedTouches[0].clientY;
				resetState();

				updateViewportCache();

				const disableTransitions = [
					{ transition: 'none', transitionProperty: 'none', transitionDuration: '0ms' },
					{ transition: 'none', transitionProperty: 'none', transitionDuration: '0ms' },
					{ transition: 'none', transitionProperty: 'none', transitionDuration: '0ms' }
				];
				applyStylesToSlides(disableTransitions);

				touchTimer = setTimeout(() => {
					if (this.activeVideo && !isDragging) {
						this.activeVideo.pause();
					}
				}, TOUCH_HOLD_DURATION);
			},
			{ passive: false }
		);

		this.slider.addEventListener(
			'touchmove',
			e => {
				if (this.isAnimating || isTouchTransitioning) {
					e.preventDefault();
					return;
				}

				const currentX = e.changedTouches[0].clientX;
				const currentY = e.changedTouches[0].clientY;
				const deltaX = currentX - touchStartX;
				const deltaY = currentY - touchStartY;

				if (Math.abs(deltaX) > 10 || Math.abs(deltaY) > 10) {
					if (isHorizontalSwipe === null) {
						const horizontalRatio = Math.abs(deltaX) / (Math.abs(deltaY) + 1);
						const verticalRatio = Math.abs(deltaY) / (Math.abs(deltaX) + 1);

						isHorizontalSwipe = horizontalRatio > 1.5;

						if (verticalRatio > 2) {
							isHorizontalSwipe = false;
							return;
						}
					}

					if (isHorizontalSwipe) {
						e.preventDefault();
						isDragging = true;

						if (touchTimer) {
							clearTimeout(touchTimer);
							touchTimer = null;
						}

						requestAnimFrame(() => {
							applyTouchTransforms(deltaX);
						});
					}
				}
			},
			{ passive: false }
		);

		const resumeVideoPlayback = (shouldResume = true) => {
			if (this.activeVideo && this.activeVideo.paused && shouldResume) {
				setTimeout(() => {
					this.activeVideo.play().catch(error => {
						console.warn('Video playback failed:', error);
					});
				}, 100);
			}
		};

		this.slider.addEventListener(
			'touchend',
			e => {
				if (this.isAnimating || isTouchTransitioning) {
					e.preventDefault();
					cleanup();
					resetState();
					return;
				}

				const touchEndX = e.changedTouches[0].clientX;
				const deltaX = touchEndX - touchStartX;
				const swipeThreshold = maxTranslate;

				cleanup();

				if (isHorizontalSwipe && isDragging) {
					if (Math.abs(deltaX) > MIN_SWIPE_DISTANCE && Math.abs(deltaX) > swipeThreshold) {
						isTouchTransitioning = true;

						const direction = deltaX > 0 ? -1 : 1;
						const slideChangeDuration = 400;

						setSlideTransitions(slideChangeDuration);

						const slideChangePositions =
							direction > 0
								? [
										{ transform: 'translate3d(-200%, 0, 0)' },
										{ transform: 'translate3d(-100%, 0, 0)' },
										{ transform: 'translate3d(0%, 0, 0)' }
								  ]
								: [
										{ transform: 'translate3d(0%, 0, 0)' },
										{ transform: 'translate3d(100%, 0, 0)' },
										{ transform: 'translate3d(200%, 0, 0)' }
								  ];

						applyStylesToSlides(slideChangePositions);
						this.updateSliderFromTouch(direction);

						setTimeout(() => {
							resetSlideTransforms();
							isTouchTransitioning = false;
						}, slideChangeDuration);
					} else {
						animateSlidesToPosition(150);
						resumeVideoPlayback(Math.abs(deltaX) <= swipeThreshold);
					}
				} else {
					animateSlidesToPosition(120);
					resumeVideoPlayback();
				}

				resetState();
			},
			{ passive: false }
		);

		this.slider.addEventListener(
			'touchcancel',
			() => {
				if (this.isAnimating || isTouchTransitioning) {
					return;
				}

				cleanup();
				animateSlidesToPosition(150);
				resumeVideoPlayback();
				resetState();
			},
			{ passive: true }
		);
	}

	handleSwipe(startX, endX) {
		const diff = startX - endX;
		const MIN_SWIPE_DISTANCE = 30;
		if (Math.abs(diff) > MIN_SWIPE_DISTANCE) {
			if (diff > 0) {
				this.updateSlider(1);
			} else {
				this.updateSlider(-1);
			}
		}
	}

	attachVideoEndListener(activeVideo) {
		if (activeVideo) {
			let activeVideoDuration = null;

			// Check if metadata is already loaded
			if (activeVideo.readyState >= 1) {
				activeVideoDuration = activeVideo.duration;

				if (activeVideoDuration > 4) {
					activeVideo.onended = null;
					activeVideo.addEventListener(
						'ended',
						() => {
							activeVideo.play().catch(error => {
								console.warn('Video playback failed:', error);
							});
							activeVideo.play();
							this.updateSlider(1);
						},
						{ once: true }
					);
				} else {
					this.attachSlideTimeout();
				}
			} else {
				activeVideo.addEventListener(
					'loadedmetadata',
					() => {
						activeVideoDuration = activeVideo.duration;

						if (activeVideoDuration > 4) {
							activeVideo.onended = null;
							activeVideo.addEventListener(
								'ended',
								() => {
									activeVideo.play();
									this.updateSlider(1);
								},
								{ once: true }
							);
						} else {
							this.attachSlideTimeout();
						}
					},
					{ once: true }
				);
			}
		}
	}

	attachSlideTimeout() {
		if (this.slideTimeout) {
			clearTimeout(this.slideTimeout);
		}

		if (this.activeVideo) {
			this.activeVideo.loop = true;
		}

		this.slideTimeout = setTimeout(() => {
			this.updateSlider(1);
		}, 8000);
	}

	initLoopButton() {
		if (this.loopButton) {
			this.loopButton.removeEventListener('mouseenter', this.loopButtonListeners.mouseenter);
			this.loopButton.removeEventListener('mouseleave', this.loopButtonListeners.mouseleave);
		}

		this.loopButton = this.activeSlideEl.querySelector('[data-trigger="loop-video"]');
		if (this.loopButton) {
			this.loopButtonListeners.mouseenter = () => {
				if (this.activeVideo) {
					this.activeVideo.loop = true;
				}
			};

			this.loopButtonListeners.mouseleave = () => {
				if (this.activeVideo) {
					this.activeVideo.loop = false;
				}
			};

			this.loopButton.addEventListener('mouseenter', this.loopButtonListeners.mouseenter);
			this.loopButton.addEventListener('mouseleave', this.loopButtonListeners.mouseleave);
		}
	}

	goToSlide(targetSlideIndex) {
		// Prevent multiple simultaneous transitions
		if (this.isAnimating || targetSlideIndex === this.currentSlide) {
			return;
		}

		// Clear any existing timeouts
		if (this.slideTimeout) {
			clearTimeout(this.slideTimeout);
			this.slideTimeout = null;
		}

		// Calculate the shortest path to target slide
		const distance = this.calculateShortestDistance(this.currentSlide, targetSlideIndex);
		const direction = distance > 0 ? 1 : -1;
		const steps = Math.abs(distance);

		if (steps === 0) {
			// Already at target slide
			return;
		} else if (steps === 1) {
			// Direct transition for adjacent slides
			this.updateSlider(direction);
		} else {
			// Improved multi-step transition for distant slides
			this.performSmoothMultiStepTransition(targetSlideIndex, direction, steps);
		}
	}

	calculateShortestDistance(current, target) {
		const forward = (target - current + this.TOTAL_SLIDES) % this.TOTAL_SLIDES;
		const backward = (current - target + this.TOTAL_SLIDES) % this.TOTAL_SLIDES;

		if (forward <= backward) {
			return forward;
		} else {
			return -backward;
		}
	}

	performSmoothMultiStepTransition(targetSlideIndex, direction, steps) {
		this.isAnimating = true;

		// Safety timeout to reset isAnimating in case something goes wrong
		const safetyTimeout = setTimeout(() => {
			console.warn('Safety timeout triggered - resetting isAnimating');
			this.cleanupCascadingTransition();
			this.isAnimating = false;
		}, steps * 1000 + 3000);

		// Create all temporary slides for the transition
		const tempSlides = this.createTemporarySlides(direction, steps);

		// Calculate timing for cascading effect
		const transitionDuration = 750; // Original transition duration
		const stepDelay = 200; // Stagger delay between each slide
		const totalDuration = (steps - 1) * stepDelay + transitionDuration;

		// Position all slides initially
		this.positionCascadingSlides(tempSlides, direction);

		// Start the cascading animation with delays
		setTimeout(() => {
			this.animateCascadingSlides(tempSlides, direction, stepDelay);
		}, 50);

		// Final cleanup after all animations complete
		setTimeout(() => {
			this.finalizeCascadingTransition(tempSlides, targetSlideIndex);
			clearTimeout(safetyTimeout);
			this.isAnimating = false;
		}, totalDuration + 200);

		// Store cleanup function for abort scenarios
		this.abortMultiStepTransition = () => {
			clearTimeout(safetyTimeout);
			this.cleanupCascadingTransition();
			this.isAnimating = false;
		};
	}

	createTemporarySlides(direction, steps) {
		const tempSlides = [];

		// Create temporary slides for each step in the transition
		for (let i = 0; i < steps; i++) {
			const slideIndex = (this.currentSlide + (i + 1) * direction + this.TOTAL_SLIDES) % this.TOTAL_SLIDES;
			const slideData = this.slides[slideIndex];

			// Create slide element
			const slideEl = new SlideBuilder(slideData, 'temp').slide;
			slideEl.dataset.cascadeIndex = i;
			slideEl.dataset.slideIndex = slideIndex;

			// Set all styles directly in JS - no CSS classes needed
			slideEl.style.position = 'absolute';
			slideEl.style.top = '0';
			slideEl.style.left = '0';
			slideEl.style.right = '0';
			slideEl.style.bottom = '0';
			slideEl.style.zIndex = 1 + i;
			slideEl.style.pointerEvents = 'none'; // Disable interactions
			slideEl.style.opacity = '0.95'; // Slightly reduced opacity

			// Position slide off-screen initially
			if (direction === 1) {
				slideEl.style.transform = `translate3d(${100 + i * 20}%, 0, 0)`;
			} else {
				slideEl.style.transform = `translate3d(${-100 - i * 20}%, 0, 0)`;
			}

			// Add to DOM
			this.slidesContainer.appendChild(slideEl);
			tempSlides.push(slideEl);
		}

		return tempSlides;
	}

	positionCascadingSlides(tempSlides, direction) {
		// Set initial positions and prepare for animation
		tempSlides.forEach((slide, index) => {
			slide.style.transition = 'transform 750ms cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 750ms ease-out';
			slide.style.opacity = '1';

			// Mute any videos in temp slides
			const video = slide.querySelector('video');
			if (video) {
				video.muted = true;
				video.pause();
			}
		});

		// Position current slides for the transition
		this.prevSlideEl.style.transition =
			'transform 750ms cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 750ms ease-out';
		this.activeSlideEl.style.transition =
			'transform 750ms cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 750ms ease-out';
		this.nextSlideEl.style.transition =
			'transform 750ms cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 750ms ease-out';
	}

	animateCascadingSlides(tempSlides, direction, stepDelay) {
		// Animate current slide out first
		setTimeout(() => {
			if (direction === 1) {
				this.activeSlideEl.style.transform = 'translate3d(-100%, 0, 0)';
				this.activeSlideEl.style.opacity = '0.7';
			} else {
				this.activeSlideEl.style.transform = 'translate3d(100%, 0, 0)';
				this.activeSlideEl.style.opacity = '0.7';
			}
		}, 0);

		// Animate each temporary slide with staggered delays
		tempSlides.forEach((slide, index) => {
			const delay = index * stepDelay;
			const slideIndex = parseInt(slide.dataset.slideIndex);

			setTimeout(() => {
				// Update current slide index for this step
				this.currentSlide = slideIndex;

				// Update bullets to show current progress
				this.updateBullets(direction);

				// Animate to center position
				slide.style.transform = 'translate3d(0%, 0, 0)';
				slide.style.opacity = '1'; // Full opacity when active
				slide.style.zIndex = '1'; // Bring to front when active

				// If not the last slide, animate it out after a moment
				if (index < tempSlides.length - 1) {
					setTimeout(() => {
						if (direction === 1) {
							slide.style.transform = 'translate3d(-100%, 0, 0)';
						} else {
							slide.style.transform = 'translate3d(100%, 0, 0)';
						}
						slide.style.opacity = '0.7';
						slide.style.zIndex = '1'; // Send back
					}, stepDelay + 100);
				}
			}, delay);
		});
	}

	finalizeCascadingTransition(tempSlides, targetSlideIndex) {
		// Update internal state to final position (currentSlide already updated during cascade)
		this.currentSlide = targetSlideIndex;

		// Get the final slide data
		const finalSlideData = this.slides[targetSlideIndex];
		const finalTempSlide = tempSlides[tempSlides.length - 1];

		// Replace current structure with final slide
		this.prevSlideEl.remove();
		this.activeSlideEl.remove();
		this.nextSlideEl.remove();

		// Create new slide structure at final position - reset all inline styles
		this.activeSlideEl = finalTempSlide;
		this.activeSlideEl.dataset.sliderItem = '0';
		this.activeSlideEl.style.position = '';
		this.activeSlideEl.style.transform = '';
		this.activeSlideEl.style.transition = '';
		this.activeSlideEl.style.opacity = '';
		this.activeSlideEl.style.zIndex = '';
		this.activeSlideEl.style.pointerEvents = '';

		// Create new prev and next slides
		this.prevSlideEl = this.renderSlide(this.slides[this.getPrevIndex()], 'prev');
		this.nextSlideEl = this.renderSlide(this.slides[this.getNextIndex()], 'next');

		// Update slide data references
		this.prevSlide = this.slides[this.getPrevIndex()];
		this.activeSlide = finalSlideData;
		this.nextSlide = this.slides[this.getNextIndex()];

		// Clean up all temporary slides except the final one
		tempSlides.forEach((slide, index) => {
			if (index < tempSlides.length - 1) {
				slide.remove();
			}
		});

		// Final bullet update to ensure correct state (bullets were updated during cascade)
		this.updateBullets(0);
		//this.updateDebugger();
		this.initLoopButton();

		// Handle video for final slide
		this.activeVideo = this.activeSlideEl.querySelector('video');
		if (this.activeVideo) {
			this.setupNewVideo();
		} else {
			this.attachSlideTimeout();
		}
	}

	cleanupCascadingTransition() {
		// Remove all temporary cascading slides (no classes to check, just remove all temps)
		const tempSlides = this.slidesContainer.querySelectorAll('[data-cascade-index]');
		tempSlides.forEach(slide => slide.remove());

		// Reset any modified styles on remaining slides
		const allSlides = this.slider.querySelectorAll('.slide');
		allSlides.forEach(slide => {
			slide.style.transition = '';
			slide.style.transform = '';
			slide.style.opacity = '';
			slide.style.zIndex = '';
			slide.style.pointerEvents = '';
		});
	}
}

let observer;
let hasAgreed = false;

if (localStorage.getItem('agreement') === 'true') {
	hasAgreed = true;
}

$(document).on('startHeroSlider', () => {
	hasAgreed = true;
	const heroSlider = document.querySelector('.hero-slider');
	if (heroSlider) {
		const activeVideo = heroSlider.querySelector('.slide[data-slider-item="0"] video');
		if (activeVideo) {
			activeVideo.muted = true;
			activeVideo.play().catch(error => {
				console.warn('Video autoplay failed:', error);
			});
		}
	}
});

document.addEventListener('DOMContentLoaded', () => {
	const heroSlider = document.querySelector('.hero-slider');

	if (heroSlider) {
		observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					const activeVideo = heroSlider.querySelector('.slide[data-slider-item="0"] video');
					if (entry.isIntersecting && hasAgreed) {
						if (activeVideo) {
							activeVideo.muted = true;
							activeVideo.play().catch(error => {
								console.warn('Video autoplay failed:', error);
							});
						}
					} else {
						if (activeVideo) {
							activeVideo.pause();
						}
					}
				});
			},
			{
				threshold: 0.1
			}
		);

		observer.observe(heroSlider);

		const activeSlideButton = heroSlider.querySelector(
			'.slide[data-slider-item="0"] .slide__content .button--width'
		);
		if (activeSlideButton) {
			activeSlideButton.addEventListener('mouseenter', () => {
				const activeVideo = heroSlider.querySelector('.slide[data-slider-item="0"] video');
				if (activeVideo) {
					activeVideo.loop = true;
				}
			});

			activeSlideButton.addEventListener('mouseleave', () => {
				const activeVideo = heroSlider.querySelector('.slide[data-slider-item="0"] video');
				if (activeVideo) {
					activeVideo.loop = false;
				}
			});
		}
	}

	if (window.slides && Array.isArray(window.slides) && window.slides.length > 0) {
		new HeroSlider(window.slides);
	}
});
